/// <amd-module name="Agile/Boards/Directory/BoardDirectoryContent" />
import { AreaName, LOAD_DIRECTORY } from "Agile/Boards/Directory/BoardDirectoryConstants";
import { artifactName } from "Agile/Boards/Directory/Resources";
import { ConnectedDirectoryContentView } from "Agile/Directory/Components/DirectoryContentView";
import * as React from "react";
import { connect } from "react-redux";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { VssHubViewState } from "VSSUI/Navigation/VssHubViewState";

export interface BoardDirectoryContentProvidedProps {
    hubViewState: VssHubViewState;
}

class BoardDirectoryContent extends VssComponent<BoardDirectoryContentProvidedProps> {
    public constructor(props: BoardDirectoryContentProvidedProps, context?: IVssComponentContext) {
        super(props, context);
    }

    public render() {
        return (
            <>
                <ConnectedDirectoryContentView
                    artifactName={artifactName}
                    artifactIcon={{ iconName: "BacklogBoard" }}
                    hubViewState={this.props.hubViewState}
                    ttiScenarioProps={{
                        areaName: AreaName,
                        featureName: LOAD_DIRECTORY
                    }}
                />
            </>
        );
    }
}

function mapStateToProps(state: any, ownProps: BoardDirectoryContentProvidedProps): BoardDirectoryContentProvidedProps {
    return {
        hubViewState: ownProps.hubViewState
    };
}

export const ConnectedBoardDirectoryContent = connect(
    mapStateToProps
)(BoardDirectoryContent);
